import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/facebookPixel';

// Hook to automatically track page views on route changes
export const useFacebookPixelPageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when the location changes
    trackPageView();
  }, [location.pathname, location.search]);
};

// Hook to track specific events
export const useFacebookPixelTracking = () => {
  return {
    trackPageView,
    // You can add more specific tracking functions here if needed
  };
};
